import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { GetFertilizerOfferCryptoContentMutationResponse, GetFertilizerOfferCryptoContentPathParams } from "../../types/GetFertilizerOfferCryptoContent";

/**
     * @summary Получение данных офферты для крипто подписи
     * @link /api/orders/:orderId/sign/crypto-template
     */
export async function getFertilizerOfferCryptoContent (orderId: GetFertilizerOfferCryptoContentPathParams["orderId"], options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<GetFertilizerOfferCryptoContentMutationResponse>["data"]> {
    const { data: resData } = await client<GetFertilizerOfferCryptoContentMutationResponse>({
        method: "post",
        url: `/api/orders/${orderId}/sign/crypto-template`,
        ...options
    });
    
    return resData;
};